import {
  ErrorNotification,
  SuccessNotification,
  Text,
  WarningNotification,
} from '@epam/promo';
import { useUuiContext } from '@epam/uui-core';
import { getDataTestIdValue } from 'hooks/helpers/common';

const NOTIFICATION_LEVEL = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
} as const;

export const useToast = () => {
  const { uuiNotifications } = useUuiContext();

  const useSuccessToast = (message: string) =>
    uuiNotifications
      .show(({ key, id, onClose, onSuccess }) => (
        <SuccessNotification
          key={key}
          id={id}
          rawProps={{ 'data-testid': getDataTestIdValue(message) }}
          onClose={onClose}
          onSuccess={onSuccess}>
          <Text color="gray80">{message}</Text>
        </SuccessNotification>
      ))
      .catch(() => null);

  const useErrorToast = (message: string) =>
    uuiNotifications
      .show(({ key, id, onClose, onSuccess }) => (
        <ErrorNotification
          key={key}
          id={id}
          rawProps={{ 'data-testid': 'error-toast-message' }}
          onClose={onClose}
          onSuccess={onSuccess}>
          <Text color="gray80">{message}</Text>
        </ErrorNotification>
      ))
      .catch(() => null);

  const useWarningToast = (message: string) =>
    uuiNotifications
      .show(({ key, id, onClose, onSuccess }) => (
        <WarningNotification
          key={key}
          id={id}
          rawProps={{ 'data-testid': 'warning-toast-message' }}
          onClose={onClose}
          onSuccess={onSuccess}>
          <Text color="gray80">{message}</Text>
        </WarningNotification>
      ))
      .catch(() => null);

  const toast = {
    [NOTIFICATION_LEVEL.SUCCESS]: useSuccessToast,
    [NOTIFICATION_LEVEL.ERROR]: useErrorToast,
    [NOTIFICATION_LEVEL.WARNING]: useWarningToast,
  };

  return toast;
};
